export default "__VITE_ASSET__26c412a5__"